export default {
  notFound: {
    title: 'Esta página no ha sido generada',
    message: 'Dime qué te gustaría que tuviera esta página',
    backHome: 'Volver al inicio',
    contact: 'Ir a contacto',
  },
};